export default "__VITE_ASSET__3mRLQuaV__"